<script lang="ts">
  import clsx from "clsx";
  import { Loader } from "lucide-svelte";

  let clazz: string | null = null;
  export { clazz as class };
</script>

<Loader class={clsx("animate-spin", clazz)} />
